import * as React from 'react';

import {ButtonCard} from '../card/button-card';

import {OptionCardContent} from './option-card-content';
import type {Props as OptionCardContentProps} from './option-card-content';

type Props = OptionCardContentProps & {
    onClick: () => void;
    isSelected?: boolean;
};

export function OptionCardChooser({onClick, isSelected, ...restProps}: Props) {
    return (
        <ButtonCard onClick={onClick} isSelected={isSelected}>
            <OptionCardContent {...restProps} />
        </ButtonCard>
    );
}
